<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="commission-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 顶部搜索栏（折叠版） -->
        <div class="search-bar">
          <!-- 折叠/展开按钮 -->
          <el-button
            icon="el-icon-arrow-down"
            type="text"
            @click="toggleSearch"
            style="margin-right: 10px"
          >
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </el-button>

          <!-- 搜索项 -->
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="请输入用户ID"
              clearable
              style="width: 180px"
            ></el-input>
            <el-select
              v-model="searchParams.status"
              placeholder="请选择状态"
              clearable
              style="width: 160px"
            >
              <el-option label="待结算" :value="0"></el-option>
              <el-option label="已结算" :value="1"></el-option>
            </el-select>
          </div>

          <!-- 搜索/重置/列筛选 -->
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getCommissionList"
            >
              搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">
              重置
            </el-button>
            <el-popover
              placement="bottom"
              title="显示列筛选"
              trigger="click"
              width="220"
            >
              <el-checkbox-group v-model="checkedColumns">
                <el-checkbox
                  v-for="item in columnOptions"
                  :key="item.prop"
                  :label="item.prop"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
              <div style="text-align: right; margin-top: 8px">
                <el-button size="mini" @click="handleCheckAll">全选</el-button>
                <el-button size="mini" @click="handleClearAll">清空</el-button>
              </div>
              <el-button slot="reference" icon="el-icon-s-tools" type="info"
                >列筛选</el-button
              >
            </el-popover>
          </div>
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handleRowClick"
        >
          <el-table-column
            label="头像"
            width="80"
            align="center"
            v-if="checkedColumns.includes('avatar')"
          >
            <template slot-scope="scope">
              <el-avatar :src="scope.row.avatar" size="40"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="120"
            align="center"
            v-if="checkedColumns.includes('user_id')"
          />
          <el-table-column
            label="用户昵称"
            prop="nickname"
            min-width="150"
            v-if="checkedColumns.includes('nickname')"
          />
          <el-table-column
            label="宝箱ID"
            prop="box_id"
            width="120"
            align="center"
            v-if="checkedColumns.includes('box_id')"
          />
          <el-table-column
            label="宝箱名称"
            prop="box_name"
            min-width="180"
            v-if="checkedColumns.includes('box_name')"
          />
          <el-table-column
            label="类型"
            width="100"
            align="center"
            v-if="checkedColumns.includes('type')"
          >
            <template slot-scope="scope">
              <span
                :style="{ color: scope.row.type == 1 ? '#67C23A' : '#E6A23C' }"
              >
                {{ scope.row.type == 1 ? "无限" : "擂台" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            prop="num"
            width="100"
            align="center"
            v-if="checkedColumns.includes('num')"
          />
          <el-table-column
            label="返佣金额"
            prop="commission"
            width="120"
            align="center"
            v-if="checkedColumns.includes('commission')"
          />
          <el-table-column
            label="操作"
            width="150"
            align="center"
            fixed="right"
            v-if="checkedColumns.includes('action')"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-view"
                style="color: #409eff"
                @click.stop="openDetailDialog(scope.row)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 详情弹窗 -->
        <el-dialog
          title="返佣详情"
          :visible.sync="detailVisible"
          width="1100px"
          append-to-body
        >
          <div v-loading="detailLoading">
            <el-table
              :data="detailData"
              border
              size="small"
              style="width: 100%"
            >
              <el-table-column label="头像" width="80" align="center">
                <template slot-scope="scope">
                  <el-avatar :src="scope.row.avatar" size="40"></el-avatar>
                </template>
              </el-table-column>
              <el-table-column
                label="用户ID"
                prop="user_id"
                width="120"
                align="center"
              />
              <el-table-column
                label="用户昵称"
                prop="nickname"
                min-width="150"
              />
              <el-table-column
                label="宝箱ID"
                prop="box_id"
                width="120"
                align="center"
              />
              <el-table-column
                label="宝箱名称"
                prop="box_name"
                min-width="180"
              />
              <el-table-column label="类型" width="100" align="center">
                <template slot-scope="scope">
                  <span
                    :style="{
                      color: scope.row.type == 1 ? '#67C23A' : '#E6A23C',
                    }"
                  >
                    {{ scope.row.type == 1 ? "无限" : "擂台" }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="数量"
                prop="num"
                width="100"
                align="center"
              />
              <el-table-column
                label="返佣金额"
                prop="commission"
                width="120"
                align="center"
              />
            </el-table>

            <el-pagination
              @current-change="getDetailList"
              :current-page="detailParams.page"
              :page-size="detailParams.page_size"
              layout="prev, pager, next"
              :total="detailTotal"
              style="text-align: center; margin-top: 15px"
            ></el-pagination>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-commission-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 搜索 -->
        <div class="mobile-search-group">
          <el-button
            type="text"
            icon="el-icon-arrow-down"
            @click="toggleSearch"
            style="width: 100%; text-align: left; padding-left: 0"
          >
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </el-button>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            />
            <el-select
              v-model="searchParams.status"
              placeholder="状态"
              clearable
              size="medium"
            >
              <el-option label="待结算" :value="0"></el-option>
              <el-option label="已结算" :value="1"></el-option>
            </el-select>
          </div>
        </div>
        <div style="display: flex; gap: 8px; margin-bottom: 10px">
          <el-button
            type="primary"
            plain
            round
            @click="getCommissionList"
            style="flex: 1"
            >搜索</el-button
          >
          <el-button plain round @click="resetSearch" style="flex: 1"
            >重置</el-button
          >
        </div>

        <!-- 卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.user_id + item.box_id"
            @click="openDetailDialogMobile(item)"
          >
            <div class="card-header">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-avatar :src="item.avatar" size="50"></el-avatar>
                <div class="info">
                  <div class="nickname">{{ item.nickname || "未知用户" }}</div>
                  <div class="uid">
                    用户ID: {{ item.user_id }} · 宝箱ID: {{ item.box_id }}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div>宝箱名称：{{ item.box_name }}</div>
              <div>
                类型：
                <span
                  :style="{ color: item.type == 1 ? '#67C23A' : '#E6A23C' }"
                >
                  {{ item.type == 1 ? "无限" : "擂台" }}
                </span>
              </div>
              <div>数量：{{ item.num }}</div>
              <div>返佣金额：¥{{ item.commission }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openDetailDialogMobile(item)"
                >查看详情</el-button
              >
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            layout="total, prev, pager, next"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗（卡片列表） -->
        <el-dialog
          title="返佣详情"
          :visible.sync="detailVisibleMobile"
          width="95%"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-loading="detailLoading">
            <div class="mobile-card-list" style="padding: 0">
              <div
                class="mobile-card"
                v-for="item in detailData"
                :key="item.user_id + item.box_id"
                style="margin-bottom: 10px"
              >
                <div class="card-header">
                  <div style="display: flex; align-items: center; gap: 10px">
                    <el-avatar :src="item.avatar" size="50"></el-avatar>
                    <div class="info">
                      <div class="nickname">
                        {{ item.nickname || "未知用户" }}
                      </div>
                      <div class="uid">
                        用户ID: {{ item.user_id }} · 宝箱ID: {{ item.box_id }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div>宝箱名称：{{ item.box_name }}</div>
                  <div>
                    类型：
                    <span
                      :style="{ color: item.type == 1 ? '#67C23A' : '#E6A23C' }"
                    >
                      {{ item.type == 1 ? "无限" : "擂台" }}
                    </span>
                  </div>
                  <div>数量：{{ item.num }}</div>
                  <div>返佣金额：¥{{ item.commission }}</div>
                </div>
              </div>
            </div>

            <el-pagination
              @current-change="getDetailListMobile"
              :current-page="detailParams.page"
              layout="prev, pager, next"
              :total="detailTotal"
              style="margin-top: 10px; text-align: center"
            ></el-pagination>
          </div>
          <div slot="footer">
            <el-button @click="detailVisibleMobile = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "UserCustomCommission",
  data() {
    return {
      loading: false,
      detailLoading: false,
      tableData: [],
      pageInfo: { total: 0 },

      // 主列表搜索参数
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
        status: 0,
      },

      // 详情请求参数
      detailParams: {
        page: 1,
        page_size: 10,
        user_id: "",
        status: "",
        type: "",
        box_id: "",
      },
      detailData: [],
      detailTotal: 0,
      detailVisible: false,
      detailVisibleMobile: false,

      // 列筛选
      columnOptions: [
        { label: "头像", prop: "avatar" },
        { label: "用户ID", prop: "user_id" },
        { label: "用户昵称", prop: "nickname" },
        { label: "宝箱ID", prop: "box_id" },
        { label: "宝箱名称", prop: "box_name" },
        { label: "类型", prop: "type" },
        { label: "数量", prop: "num" },
        { label: "返佣金额", prop: "commission" },
        { label: "操作", prop: "action" },
      ],
      checkedColumns: [
        "avatar",
        "user_id",
        "nickname",
        "box_id",
        "box_name",
        "type",
        "num",
        "commission",
        "action",
      ],

      searchCollapsed: true,
    };
  },
  created() {
    this.getCommissionList();
  },
  methods: {
    // 主列表
    async getCommissionList() {
      this.loading = true;
      try {
        const res = await api.users.customCommission({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data || [];
          this.pageInfo.total = res.data.data.total || 0;
        }
      } finally {
        this.loading = false;
      }
    },

    // 获取详情列表
    async getDetailList(page = 1) {
      this.detailLoading = true;
      this.detailParams.page = page;
      try {
        const res = await api.users.customCommissionDetail({
          params: this.detailParams,
        });
        if (res.data.code == 1000) {
          this.detailData = res.data.data.data || [];
          this.detailTotal = res.data.data.total || 0;
        }
      } finally {
        this.detailLoading = false;
      }
    },

    // 打开 PC 详情
    openDetailDialog(row) {
      this.detailParams.user_id = row.user_id;
      this.detailParams.box_id = row.box_id;
      this.detailParams.type = row.type;
      this.detailParams.status = this.searchParams.status;
      this.detailParams.page = 1;
      this.detailVisible = true;
      this.getDetailList();
    },

    // 打开移动端详情
    openDetailDialogMobile(row) {
      this.detailParams.user_id = row.user_id;
      this.detailParams.box_id = row.box_id;
      this.detailParams.type = row.type;
      this.detailParams.status = this.searchParams.status;
      this.detailParams.page = 1;
      this.detailVisibleMobile = true;
      this.getDetailList();
    },

    // 移动端详情分页
    async getDetailListMobile(page) {
      this.detailParams.page = page;
      this.getDetailList();
    },

    // 重置
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
        status: 0,
      };
      this.getCommissionList();
    },

    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getCommissionList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getCommissionList();
    },

    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },

    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
    handleRowClick() {},
  },
};
</script>

<style scoped>
/* PC样式 */
.commission-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 移动端样式 */
.mobile-commission-container {
  padding: 12px;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  margin-bottom: 10px;
}
.info .nickname {
  font-size: 16px;
  font-weight: 500;
}
.info .uid {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 10px;
}
.card-footer {
  text-align: right;
}
</style>

<style>
@media (max-width: 768px) {
  .pc-version {
    display: none !important;
  }
  .mobile-version {
    display: block !important;
  }
  .mobile-dialog {
    border-radius: 12px !important;
  }
  .mobile-dialog .el-dialog__body {
    padding: 15px !important;
  }
}
@media (min-width: 769px) {
  .pc-version {
    display: block !important;
  }
  .mobile-version {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/customCommission.vue